import { render, staticRenderFns } from "./usrSwJoinAuthConfirm.vue?vue&type=template&id=6340fb21&scoped=true"
import script from "./usrSwJoinAuthConfirm.vue?vue&type=script&lang=js"
export * from "./usrSwJoinAuthConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6340fb21",
  null
  
)

export default component.exports